module.exports = __webpack_public_path__ + "img/symbol_5.67aa0e8e.png";